import React, { useEffect, useRef } from "react";
import {
    Chart,
    ArcElement,
    Tooltip,
    Legend
} from "chart.js";

Chart.register(ArcElement, Tooltip, Legend);

export default function GradientPieChart() {
    const chartRef = useRef(null);

    useEffect(() => {
        const ctx = chartRef.current.getContext("2d");

        // 🎨 Define gradient colors
        const gradients = [
            ["#7B5FFF", "#6025FF"],
            ["#9B70FF", "#B88CFF"],
            ["#C59FFF", "#D5B8FF"],
            ["#E3D1FF", "#EFE2FF"],
            ["#F7F3FF", "#FFFFFF"]
        ].map(([start, end]) => {
            const g = ctx.createLinearGradient(0, 0, 0, 400);
            g.addColorStop(0, start);
            g.addColorStop(1, end);
            return g;
        });

        const chart = new Chart(ctx, {
            type: "pie",
            data: {
                labels: ["80C", "HRA", "80D", "80E", "Others"],
                datasets: [
                    {
                        data: [45.2, 28.7, 15.3, 6.8, 4.0],
                        backgroundColor: gradients,
                        borderColor: "transparent",
                        borderWidth: 0,
                    },
                ],
            },
            options: {
                layout: {
                    padding: {
                        top: 10,
                        bottom: 10,
                        left: 20,
                        right: 20
                    },
                },
                plugins: {
                    legend: {
                        position: "bottom",
                        labels: {
                            usePointStyle: true,
                            boxWidth: 7,
                            boxHeight: 7,
                            color: "#fff",
                            padding: 9,
                        },
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: (ctx) => `${ctx.label}: ${ctx.parsed}%`,
                        },
                    },
                },

                elements: {
                    arc: { borderRadius: 6 },
                },
            },
            plugins: [
                {
                    id: "customLabels",
                    afterDatasetsDraw(chart) {
                        const { ctx, chartArea, data } = chart;
                        const meta = chart.getDatasetMeta(0);
                        const centerX = (chartArea.left + chartArea.right) / 2;
                        const centerY = (chartArea.top + chartArea.bottom) / 2;

                        ctx.save();
                        ctx.font = "bold 12px Outfit";
                        ctx.fillStyle = "#fff";
                        ctx.strokeStyle = "#fff";
                        ctx.lineWidth = 1;
                        ctx.lineHeight = 10;
                        ctx.textBaseline = "middle";

                        const usedY = []; // avoid overlap

                        meta.data.forEach((arc, i) => {
                            const angle = (arc.startAngle + arc.endAngle) / 2;
                            const radius = arc.outerRadius * 1;
                            const x = centerX + Math.cos(angle) * radius;
                            const y = centerY + Math.sin(angle) * radius;
                            const endX = centerX + Math.cos(angle) * (radius + 15);
                            let endY = centerY + Math.sin(angle) * (radius + 15);

                            // 🔧 prevent overlapping by adjusting Y
                            while (usedY.some((yy) => Math.abs(yy - endY) < 10)) {
                                endY += 10;
                            }
                            usedY.push(endY);

                            const label = `${data.labels[i]}: ${data.datasets[0].data[i]}%`;

                            // Line
                            ctx.beginPath();
                            ctx.moveTo(x, y);
                            ctx.lineTo(endX, endY);
                            ctx.lineTo(endX + (Math.cos(angle) > 0 ? 10 : -10), endY);
                            ctx.stroke();

                            // Text
                            ctx.textAlign = Math.cos(angle) > 0 ? "left" : "right";
                            ctx.fillText(label, endX + (Math.cos(angle) > 0 ? 15 : -15), endY);
                        });

                        ctx.restore();
                    },
                },
            ],
        });

        return () => chart.destroy();
    }, []);

    return (
        <div>
            <canvas ref={chartRef} />
        </div>
    );
}


